// extracted by mini-css-extract-plugin
export default {"h2":"EventsList_h2__atmYl","events":"EventsList_events__ZN-MV"};